"use client";

import Link from "next/link";
import { motion } from "framer-motion";

export function CTABlock() {
  return (
    <section id="contact" className="pt-12 sm:pt-20 pb-20 sm:pb-32 px-4 sm:px-8 max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="bg-landing-text rounded-3xl p-10 sm:p-16 relative overflow-hidden text-center"
      >
        <div className="relative z-10 max-w-3xl mx-auto">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-white mb-6">
            Ready to add an agentic CPA workforce to your firm?
          </h2>
          <p className="text-landing-surface mb-6 text-lg">
            Learn how Dezu can save you critical time for what matters most.
          </p>
          <div className="flex flex-col items-center justify-center gap-6 mt-10">
            <Link
              href="https://cal.com/riyadev/15min"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-landing-primary text-white px-12 py-5 rounded-full font-bold text-lg hover:bg-landing-primary-hover transition-all hover:scale-105 shadow-xl"
            >
              Book a Demo
            </Link>
            <a
              href="mailto:founders@dezu.ai"
              className="text-white/60 hover:text-white transition-colors text-sm font-medium"
            >
              Or reach us at founders@dezu.ai →
            </a>
          </div>
        </div>
        {/* Amethyst blur decorations */}
        <div aria-hidden="true" className="absolute -bottom-24 -right-24 w-96 h-96 bg-landing-primary blur-[120px] opacity-20" />
        <div aria-hidden="true" className="absolute -top-24 -left-24 w-96 h-96 bg-landing-primary blur-[120px] opacity-10" />
      </motion.div>
    </section>
  );
}
